import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useScript } from '@Green-Dot-Corporation/web-app-utils-hooks';

const augmentPageInfo = (page) => {
    const { pageInfo } = page;

    // eslint-disable-next-line no-param-reassign
    page.pageInfo = {
        ...pageInfo,
        pageName: document.title,
        modalName: '', // TODO: modal name?
    };
};

const augmentUserInfo = (user) => {
    const [info] = user;
    const { profile } = info;
    const [userProfile] = profile;
    const { profileInfo } = userProfile;

    // TODO: update user info
    userProfile.profileInfo = {
        ...profileInfo,
        custId: '',
        status: 'logged_out',
        personID: '',
        AccountReferenceID: '',
        email: '',
        account_id: '',
        reg_status: '',
        cardtype: '',
    };
};

const augmentImpactInfo = (impact) => {
    const { impactinfo } = impact;

    // TODO: update impact
    // eslint-disable-next-line no-param-reassign
    impact.impactinfo = {
        ...impactinfo,
        customerID: '',
        orderId: '',
    };
};

const preloadedEvents = [];
const eventHandler = (appConfig, scope) => {
    if (!scope.digitalData) {
        // eslint-disable-next-line no-param-reassign
        scope.digitalData = {
            page: {
                pageInfo: {
                    brand: String(appConfig.programCode).toLowerCase(),
                    site: 'secure',
                    channel: 'enroll',
                    programCode: String(appConfig.programCode).toLowerCase(),
                    productCode: String(appConfig.productCode).toLowerCase(),
                    siteRendered: 'responsive',
                },
            },
            user: [
                {
                    profile: [
                        {
                            profileInfo: {
                                custId: '',
                                status: 'logged_out',
                                personID: '',
                                AccountReferenceID: '',
                                email: '',
                                account_id: '',
                                reg_status: '',
                                cardtype: '',
                            },
                        },
                    ],
                },
            ],
            impact: {
                impactinfo: {
                    customerID: '',
                    orderId: '',
                },
            },
        };
    }

    return (eventName, options) => {
        const { _satellite: adobe } = scope;

        if (adobe) {
            augmentPageInfo(scope.digitalData.page, options);
            augmentUserInfo(scope.digitalData.user, options);
            augmentImpactInfo(scope.digitalData.impact, options);

            while (preloadedEvents.length) {
                adobe.track(preloadedEvents[0]);
                // console.log(preloadedEvents[0]);

                preloadedEvents.shift();
            }

            adobe.track(eventName);
            // console.log(eventName);
        } else {
            preloadedEvents.push(eventName);
        }

        return eventName;
    };
};

let adobeLaunchEventHandler;
const AdobeLaunch = ({ appConfig, url, onInitialized }) => {
    useScript(url);

    useEffect(() => {
        if (!adobeLaunchEventHandler) {
            adobeLaunchEventHandler = eventHandler(appConfig, window);
        }
        onInitialized(adobeLaunchEventHandler);
    }, [appConfig, onInitialized]);

    return <div style={{ display: 'none' }} data-adobe-launch={url} />;
};

AdobeLaunch.propTypes = {
    url: PropTypes.string.isRequired,
    appConfig: PropTypes.object.isRequired,
    onInitialized: PropTypes.func.isRequired,
};

export default AdobeLaunch;
